export default __webpack_public_path__ + "static/media/small_shawnipedia.33770104.png";